import React from 'react'
import Slides from '../slides/Slides'
import { Link } from 'react-router-dom';
import Footer from '../footer/Footer';

const Institucional = ({M}) => {
   return (
      <>
         <Slides M={M} tipoSlides={"institucional"} />
         <div className="section animated fadeIn">
            <div className="row center">
               <div className="col s12 m12 l12 x12">
                  <Link to={""} className="btn btn-large waves-effect waves-light bg-latitud pulse" type="submit">Descargá Nuestra Presentación
                     (PDF)
                     <i className="material-icons right">cloud_download</i>
                  </Link>
               </div>
            </div>
         </div>
         <div className="section white py-5 animated fadeIn">
            <div className="container">
               <div className="row justify-content-center">
                  <div className="col s12 m11 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '35px' }}>
                        <h4 className="light-blue-text text-darken-2 institutional-title mb-3" style={{ fontWeight: '600', letterSpacing: '0.5px' }}>
                           MISIÓN
                        </h4>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                           La misión de nuestra aseguradora es la de generar relaciones con nuestros clientes a largo plazo, brindándoles el respaldo de una compañía con experiencia, un contacto directo con los responsables, todo ello, dentro de la normativa vigente y valores éticos.
                        </p>
                     </div>
                  </div>
               </div>
            </div>      
         </div>
         <div className="section grey lighten-4 py-5 animated fadeIn">
            <div className="container">
               <div className="row justify-content-center">
                  <div className="col s12 m11 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#ffffff', padding: '35px' }}>
                        <h4 className="light-blue-text text-darken-2 institutional-title mb-3" style={{ fontWeight: '600', letterSpacing: '0.5px' }}>
                           VISIÓN
                        </h4>
                        <p className="grey-text text-darken-2" style={{ fontSize: '1.15rem', lineHeight: '1.7' }}>
                           Ser la aseguradora de empresas número uno de la región cumpliendo los más altos estándares de calidad y contando con un equipo humano de excelencia.
                        </p>
                     </div>
                  </div>
               </div>
            </div>      
         </div>
         <div className="section animated fadeIn">
            <div className="row center">
               <h4 className="light-blue-text text-accent-3 institutional-title">PRINCIPIOS</h4>
            </div> 
            <div className="container">
               <div className="row institutional-values-row justify-content-center">
                  {[
                     'Transparencia', 'Concientización', 'Centralización', 'Innovación',
                     'Eficiencia organizacional', 'Calidad de Procesos', 'Equipo de Excelencia', 'Satisfacción del cliente'
                  ].map((principio, index) => (
                     <div className="col s12 m6 l3 institutional-chip-col mb-3" key={index}>
                        <div className="chip light-blue darken-3 white-text z-depth-1 institutional-chip center-align" style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                           {principio}
                        </div>
                     </div>
                  ))}
               </div>
            </div>
         </div>
         <div className="section grey lighten-2 animated fadeIn">
            <div className="container">
               <div className="row center">
                  <h4 className="light-blue-text text-accent-3 institutional-title mb-4">AUTORIDADES</h4>
               </div>
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderRadius: '8px', backgroundColor: '#e0e0e0', padding: '25px', borderLeft: '5px solid #039be5' }}>
                        <div className="collection institutional-collection" style={{ border: 'none', margin: '0' }}>
                           {[
                              { cargo: 'Presidente', nombre: 'Lic. Cristian José Luis Zampini' },
                              { cargo: 'Vicepresidente', nombre: 'Sr. Juan Gabriel Valero Zazzarini' },
                              { cargo: 'Director Titular', nombre: 'Sr. Nelson Federico Bartoletti' },
                              { cargo: 'Director Titular', nombre: 'Ing. Pablo Marcelo Jenefes Quevedo' },
                              { cargo: 'Director Titular', nombre: 'Sr. Federico Olver Yáñez' },
                              { cargo: 'Director Titular', nombre: 'Sr. Marcelo Guillermo Casasco' },
                              { cargo: 'Director Titular', nombre: 'Sr. Nelson Policarpo Llanos' },
                              { cargo: 'Director Titular', nombre: 'Sra. Andrea Marcela Vedia' },
                              { cargo: 'Director Independiente', nombre: 'CPN. Omar Kamal Musri' },
                              { cargo: 'Director Suplente', nombre: 'Sr. Juan Mateo Aguiar' },
                              { cargo: 'Director Suplente', nombre: 'Sr. Jose Luis Cianchino' },
                              { cargo: 'Síndico Titular', nombre: 'Dr. Horacio Antonio Macedo' },
                              { cargo: 'Síndico Titular', nombre: 'CPN Normando Darío Siles' },
                              { cargo: 'Síndico Titular', nombre: 'Dr. Fernando Jose Yécora' },
                              { cargo: 'Síndico Suplente', nombre: 'Dr. Juan Sebastian Jenefes Quevedo' },
                              { cargo: 'Síndico Suplente', nombre: 'CPN Nanci Isabel Berardi' },
                              { cargo: 'Síndico Suplente', nombre: 'Dr. Ítalo Gerardo Pascuttini' },
                              { cargo: 'Gerente General', nombre: 'CPN Carlos Alberto Enrique Barni' },
                           ].map((item, idx) => (
                              <div 
                                 className="collection-item institutional-item" 
                                 key={idx}
                                 style={{ backgroundColor: '#eeeeee', borderBottom: '1px solid #d5d5d5', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '14px 20px' }}
                              >
                                 <span className="light-blue-text text-darken-2 institutional-cargo" style={{ fontWeight: '500' }}><strong>{item.cargo}:</strong></span>
                                 <span className="institutional-nombre grey-text text-darken-3" style={{ textAlign: 'right' }}>{item.nombre}</span>
                              </div>
                           ))}
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
         <div className="section white py-5 animated fadeIn">
            <div className="container">
               <div className="row center">
                  <h4 className="light-blue-text text-accent-3 institutional-title mb-4">HISTORIA</h4>
               </div> 
               <div className="row justify-content-center">
                  <div className="col s12 m12 l12">
                     <div className="card-panel z-depth-1 hoverable" style={{ borderLeft: '5px solid #039be5', borderRadius: '8px', backgroundColor: '#fafafa', padding: '40px' }}>
                        
                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           La Compañía Argentina de Seguros Latitud Sur S.A., se constituyó el día 14 de febrero de 1969, con capitales vinculados al sector asegurador nacional, aprobada por la Superintendencia de Seguros de la Nación para la producción de seguros en todo el país y con autorización para operar en la mayoría de los Ramos Patrimoniales y de Vida.
                        </p>

                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           Hacia el año 1980, el sector tabacalero de la provincia de Jujuy decidió la compra de una Aseguradora que estuviera en operaciones (en aquella época estaba prohibida la instalación de nuevas aseguradoras), con los riesgos que esto implica (pasivos ocultos). La Compañía elegida fue la Compañía Argentina de Seguros LATITUD SUR S.A., cuyo paquete accionario fue adquirido a finales del año 1982. Y todo el proceso de saneamiento de la Compañía adquirida, le llevó al sector tabacalero jujeño más de quince años, culminando éste aproximadamente en el año 2000.
                        </p>

                        <p className="grey-text text-darken-2 mb-4" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           En un primer momento, la compra fue realizada por la Cámara del Tabaco de Jujuy, en conjunto con la Cooperativa de Tabacaleros de Jujuy Ltda. Actualmente la Cámara del Tabaco de Jujuy es el accionista principal, con un 99,9% del Capital Social. Desde 1.989, se trasladó la Casa Central a Jujuy, se cerraron todas las operaciones alejadas y se concentraron todas las operaciones de la Compañía en nuestra provincia, y en un principio, exclusivamente en los riesgos vinculados con el sector tabacalero.
                        </p>

                        <p className="grey-text text-darken-2" style={{ fontSize: '1.1rem', lineHeight: '1.7' }}>
                           A comienzo del año 2000 se inició una nueva etapa, empezando a ofrecer nuestros servicios fuera del sector tabacalero jujeño. El proceso de crecimiento fue lento pero continuo, protegiendo el capital de nuestros accionistas y siendo muy cautelosos en la asunción de riesgos. Hoy somos la Aseguradora de Riesgos del Trabajo N° 1 de la Provincia de Jujuy y la N° 3 de la Provincia de Salta en cuanto al total de trabajadores asegurados.
                        </p>

                     </div>
                  </div>
               </div>
            </div>      
         </div>
      </>
   );
}

export default Institucional